/* eslint-disable no-unused-vars */
import { PDFDownloadLink } from "@react-pdf/renderer";
import React from "react";
import GlobalTable from "../../../components/global-table";
import { Button, SelectField, Typography } from "../../../ppui";
import { logger } from "../../../utils/logger";
import { ContentLayout, ContentTable } from "../../style";
import PtaxPdf from "./pdf-report";
import { PTAX_ALL_SESSION } from "./ptax-report-constant";
import { SalaryHeaders } from "./ptaxreport.data";
import usePtaxReportService from "./use-ptax-report-service";


function PTaxReport() {
  const {
    ptaxReportListData,
    ptaxReportInputs,
    handleChange,
    monthlyPtaxSummary,
    ptaxReportTableUILoading,
    restructuredPTaxData,
    ptaxDetails,
    ptaxOrgDetails,
    currentYear,
    nexttYear
  } = usePtaxReportService()
  logger.log(monthlyPtaxSummary, "monthlyPtaxSummary-gobi")
  return (
    <>
      <ContentLayout>
        <ContentTable>
          <GlobalTable
            headers={SalaryHeaders}
            rows={monthlyPtaxSummary}
            ActiveSort={false}
            searchBox={false}
            columnManagement={false}
            avatar={true}
            stickyHeader="true"
            // rowsPerPage={rowsPerPage}
            // currentPage={currentPage}
            // totalPages={totalPages}
            // handleNextPage={handleNextPage}
            // handlePreviousPage={handlePreviousPage}
            // handleRowsPerPageChange={handleRowsPerPageChange}
            // searchQuery={searchQuery}
            // setSearchQuery={setSearchQuery}
            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                  P-Tax Report {`${currentYear ? `of ${currentYear}-${nexttYear}` : ''}`}
                </Typography>
              </>
            }
            actionRight={
              <>
                <SelectField
                  label="Choose Session"
                  options={PTAX_ALL_SESSION}
                  placeholder="Select Here..."
                  onChange={(e) => handleChange(e?.target?.value || e, "session")}
                />
                {/* {ptaxReportTableUILoading ? ( */}
                <PDFDownloadLink
                  document={
                    <PtaxPdf
                      ptaxDetails={ptaxDetails}
                      restructuredPTaxData={restructuredPTaxData}
                      ptaxOrgDetails={ptaxOrgDetails}
                      currentYear={currentYear}
                      nexttYear={nexttYear}
                    />
                  }
                  fileName={`PTAX report.pdf`}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    // onClick={handleExportClick}
                    loading={ptaxReportTableUILoading}
                    disabled={restructuredPTaxData.length > 0 ? false : true}
                  >
                    Export
                  </Button>
                </PDFDownloadLink>
                {/* ) : (
                  <Button color="primary" variant="contained" disabled={true}>
                    Export
                  </Button>
                )} */}
                {/* <PDFDownloadLink
                  document={
                    <EsiPFPDFReport />
                  }
                  fileName={`PTAX report.pdf`}
                >
                  <Button
                    color="primary"
                    variant="contained"
                  >
                    Export ESIPF
                  </Button>
                </PDFDownloadLink> */}
              </>
            }
          />
        </ContentTable>
      </ContentLayout>
    </>
  );
}

export default PTaxReport;